/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

/* Edited by VT. 29-Mar-24 */
/* Update the cart qty and drawer after the add to cart from the wishlist page */
document.addEventListener('vtWishlistAddtoCart', function (event) {
document.querySelector("cart-items").getCart();
});


